import 'react';
import PropTypes from '../../../prop-types/index.js';

var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};

export { hiddenGuard };
//# sourceMappingURL=FocusGuard.js.map
